import i18nLib, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'

import * as english from './en'
import * as spanish from './es'

export const createI18nInstance = (options: InitOptions = {}) => {
  const resources = {
    en: english,
    es: spanish
  }

  const instance = i18nLib.createInstance()
  instance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      lng: 'en',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false // react already safes from xss
      },
      ...options
    })
  return instance
}

const i18nInstance = createI18nInstance()
export default i18nInstance
